/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/vendors/service.proto" (package "rd.api.vendors", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { OrderReceiveSettings } from "../../vendors/models_pb";
import { VendorLocationSettings } from "../../vendors/models_pb";
import { IntegrationVendor } from "../../proto/integration_vendor/models_pb";
import { BankPaymentMethod } from "../../payments/models_pb";
import { Contacts } from "../../vendors/models_pb";
import { Vendor } from "../../vendors/models_pb";
import { Address } from "../../proto/address/models_pb";
import { Summary } from "../../bub/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
// Vendor 

/**
 * @generated from protobuf message rd.api.vendors.CreateVendorReq
 */
export interface CreateVendorReq {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string orders_email = 2
     */
    ordersEmail: string;
    /**
     * @generated from protobuf field: string phone = 3
     */
    phone: string;
    /**
     * @generated from protobuf field: string notes = 4
     */
    notes: string;
}
/**
 * @generated from protobuf message rd.api.vendors.CreateVendorRes
 */
export interface CreateVendorRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.vendors.BulkUpsertVendorsReq
 */
export interface BulkUpsertVendorsReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: bool write_changes = 2
     */
    writeChanges: boolean;
}
/**
 * @generated from protobuf message rd.api.vendors.BulkUpsertVendorsRes
 */
export interface BulkUpsertVendorsRes {
    /**
     * @generated from protobuf field: rd.bub.Summary summary = 1
     */
    summary?: Summary;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorInformationReq
 */
export interface UpdateVendorInformationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 4
     */
    phone: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 5
     */
    address?: Address;
    /**
     * @generated from protobuf field: string pay_to = 6
     */
    payTo: string;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorInformationRes
 */
export interface UpdateVendorInformationRes {
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorNotesReq
 */
export interface UpdateVendorNotesReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string notes = 2
     */
    notes: string;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorNotesRes
 */
export interface UpdateVendorNotesRes {
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorIsActiveReq
 */
export interface UpdateVendorIsActiveReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: bool active = 2
     */
    active: boolean;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorIsActiveRes
 */
export interface UpdateVendorIsActiveRes {
}
/**
 * @generated from protobuf message rd.api.vendors.GetVendorReq
 */
export interface GetVendorReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.vendors.GetVendorRes
 */
export interface GetVendorRes {
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 1
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.vendors.Contacts contacts = 2
     */
    contacts?: Contacts;
    /**
     * @generated from protobuf field: rd.payments.BankPaymentMethod bank_payment_method = 3
     */
    bankPaymentMethod?: BankPaymentMethod;
}
/**
 * @generated from protobuf message rd.api.vendors.GetVendorByIntegrationReq
 */
export interface GetVendorByIntegrationReq {
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor integration_vendor = 1
     */
    integrationVendor: IntegrationVendor;
}
/**
 * @generated from protobuf message rd.api.vendors.GetVendorByIntegrationRes
 */
export interface GetVendorByIntegrationRes {
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 1
     */
    vendor?: Vendor;
}
/**
 * @generated from protobuf message rd.api.vendors.ListVendorsForCompanyReq
 */
export interface ListVendorsForCompanyReq {
    /**
     * @generated from protobuf field: bool filter_active = 1
     */
    filterActive: boolean;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID filter_ids = 2
     */
    filterIds: UUID[];
    /**
     * @generated from protobuf field: bool filter_connected_integration_vendor = 3
     */
    filterConnectedIntegrationVendor: boolean;
}
/**
 * @generated from protobuf message rd.api.vendors.ListVendorsForCompanyRes
 */
export interface ListVendorsForCompanyRes {
    /**
     * @generated from protobuf field: repeated rd.vendors.Vendor vendors = 1
     */
    vendors: Vendor[];
}
/**
 * @generated from protobuf message rd.api.vendors.GetActiveVendorCountReq
 */
export interface GetActiveVendorCountReq {
}
/**
 * @generated from protobuf message rd.api.vendors.GetActiveVendorCountRes
 */
export interface GetActiveVendorCountRes {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message rd.api.vendors.SaveVendorBankPaymentMethodReq
 */
export interface SaveVendorBankPaymentMethodReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string stripe_payment_method_id = 2
     */
    stripePaymentMethodId: string;
}
/**
 * @generated from protobuf message rd.api.vendors.SaveVendorBankPaymentMethodRes
 */
export interface SaveVendorBankPaymentMethodRes {
}
/**
 * @generated from protobuf message rd.api.vendors.DeleteVendorBankPaymentMethodReq
 */
export interface DeleteVendorBankPaymentMethodReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
}
/**
 * @generated from protobuf message rd.api.vendors.DeleteVendorBankPaymentMethodRes
 */
export interface DeleteVendorBankPaymentMethodRes {
}
/**
 * @generated from protobuf message rd.api.vendors.CreateVendorWithBankAccountReq
 */
export interface CreateVendorWithBankAccountReq {
    /**
     * @generated from protobuf field: string vendor_name = 1
     */
    vendorName: string;
    /**
     * @generated from protobuf field: string stripe_payment_method_id = 2
     */
    stripePaymentMethodId: string;
}
/**
 * @generated from protobuf message rd.api.vendors.CreateVendorWithBankAccountRes
 */
export interface CreateVendorWithBankAccountRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.vendors.UpsertVendorBankAccountReq
 */
export interface UpsertVendorBankAccountReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string stripe_payment_method_id = 2
     */
    stripePaymentMethodId: string;
}
/**
 * @generated from protobuf message rd.api.vendors.UpsertVendorBankAccountRes
 */
export interface UpsertVendorBankAccountRes {
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorSettingsByLocationReq
 */
export interface UpdateVendorSettingsByLocationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string default_account_number = 2
     */
    defaultAccountNumber: string;
    /**
     * @generated from protobuf field: map<string, rd.vendors.VendorLocationSettings> settings_by_location_id = 3
     */
    settingsByLocationId: {
        [key: string]: VendorLocationSettings;
    };
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorSettingsByLocationRes
 */
export interface UpdateVendorSettingsByLocationRes {
}
// Vendor Contact 

/**
 * @generated from protobuf message rd.api.vendors.CreateVendorContactReq
 */
export interface CreateVendorContactReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 3
     */
    phone: string;
    /**
     * @generated from protobuf field: string email = 4
     */
    email: string;
    /**
     * @generated from protobuf field: string notes = 5
     */
    notes: string;
}
/**
 * @generated from protobuf message rd.api.vendors.CreateVendorContactRes
 */
export interface CreateVendorContactRes {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorContactReq
 */
export interface UpdateVendorContactReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string id_string = 2
     */
    idString: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 4
     */
    phone: string;
    /**
     * @generated from protobuf field: string email = 5
     */
    email: string;
    /**
     * @generated from protobuf field: string notes = 6
     */
    notes: string;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorContactRes
 */
export interface UpdateVendorContactRes {
}
/**
 * @generated from protobuf message rd.api.vendors.DeactivateVendorContactReq
 */
export interface DeactivateVendorContactReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: string id_string = 2
     */
    idString: string;
}
/**
 * @generated from protobuf message rd.api.vendors.DeactivateVendorContactRes
 */
export interface DeactivateVendorContactRes {
}
/**
 * @generated from protobuf message rd.api.vendors.DuplicateVendorReq
 */
export interface DuplicateVendorReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
}
/**
 * @generated from protobuf message rd.api.vendors.DuplicateVendorRes
 */
export interface DuplicateVendorRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorOrderSettingsReq
 */
export interface UpdateVendorOrderSettingsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: bool disable_pdf_attachments = 2
     */
    disablePdfAttachments: boolean;
    /**
     * @generated from protobuf field: bool disable_excel_attachments = 3
     */
    disableExcelAttachments: boolean;
    /**
     * @generated from protobuf field: string orders_email = 4
     */
    ordersEmail: string;
    /**
     * @generated from protobuf field: bool should_send_prices_on_po = 5
     */
    shouldSendPricesOnPo: boolean;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorOrderSettingsRes
 */
export interface UpdateVendorOrderSettingsRes {
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorOrderReceiveSettingsReq
 */
export interface UpdateVendorOrderReceiveSettingsReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.vendors.OrderReceiveSettings order_receive_settings = 2
     */
    orderReceiveSettings?: OrderReceiveSettings;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorOrderReceiveSettingsRes
 */
export interface UpdateVendorOrderReceiveSettingsRes {
}
/**
 * @generated from protobuf message rd.api.vendors.AssignVendorSkusReq
 */
export interface AssignVendorSkusReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: bool should_sync_product_data = 2
     */
    shouldSyncProductData: boolean;
    /**
     * @generated from protobuf field: bool only_match_by_upc = 3
     */
    onlyMatchByUpc: boolean;
    /**
     * @generated from protobuf field: bool should_sync_prices = 4
     */
    shouldSyncPrices: boolean;
}
/**
 * @generated from protobuf message rd.api.vendors.AssignVendorSkusRes
 */
export interface AssignVendorSkusRes {
}
/**
 * @generated from protobuf message rd.api.vendors.ListVendorIntegrationOptionsReq
 */
export interface ListVendorIntegrationOptionsReq {
}
/**
 * @generated from protobuf message rd.api.vendors.VendorIntegrationOption
 */
export interface VendorIntegrationOption {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor integration_vendor = 2
     */
    integrationVendor: IntegrationVendor;
}
/**
 * @generated from protobuf message rd.api.vendors.ListVendorIntegrationOptionsRes
 */
export interface ListVendorIntegrationOptionsRes {
    /**
     * @generated from protobuf field: repeated rd.api.vendors.VendorIntegrationOption vendor_integration_options = 1
     */
    vendorIntegrationOptions: VendorIntegrationOption[];
}
/**
 * @generated from protobuf message rd.api.vendors.VendorLocationSettingsOption
 */
export interface VendorLocationSettingsOption {
    /**
     * Stable value to store in backend settings (e.g. "001").
     *
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * Display label for UI (e.g. "001 - New Tifton, GA").
     *
     * @generated from protobuf field: string label = 2
     */
    label: string;
}
/**
 * @generated from protobuf message rd.api.vendors.ListVendorLocationSettingsOptionsReq
 */
export interface ListVendorLocationSettingsOptionsReq {
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor integration_vendor = 1
     */
    integrationVendor: IntegrationVendor;
}
/**
 * @generated from protobuf message rd.api.vendors.ListVendorLocationSettingsOptionsRes
 */
export interface ListVendorLocationSettingsOptionsRes {
    /**
     * @generated from protobuf field: repeated rd.api.vendors.VendorLocationSettingsOption warehouse_options = 1
     */
    warehouseOptions: VendorLocationSettingsOption[];
    /**
     * @generated from protobuf field: repeated rd.api.vendors.VendorLocationSettingsOption pricing_tier_options = 2
     */
    pricingTierOptions: VendorLocationSettingsOption[];
}
/**
 * @generated from protobuf message rd.api.vendors.ListCatalogVendorIntegrationOptionsReq
 */
export interface ListCatalogVendorIntegrationOptionsReq {
}
/**
 * @generated from protobuf message rd.api.vendors.ListCatalogVendorIntegrationOptionsRes
 */
export interface ListCatalogVendorIntegrationOptionsRes {
    /**
     * @generated from protobuf field: repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors = 1
     */
    integrationVendors: IntegrationVendor[];
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorIntegrationReq
 */
export interface UpdateVendorIntegrationReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 1
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor integration_vendor = 2
     */
    integrationVendor: IntegrationVendor;
}
/**
 * @generated from protobuf message rd.api.vendors.UpdateVendorIntegrationRes
 */
export interface UpdateVendorIntegrationRes {
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateVendorReq$Type extends MessageType<CreateVendorReq> {
    constructor() {
        super("rd.api.vendors.CreateVendorReq", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "orders_email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_email": true } },
            { no: 3, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_phone": true } },
            { no: 4, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateVendorReq>): CreateVendorReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.ordersEmail = "";
        message.phone = "";
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<CreateVendorReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateVendorReq): CreateVendorReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string orders_email */ 2:
                    message.ordersEmail = reader.string();
                    break;
                case /* string phone */ 3:
                    message.phone = reader.string();
                    break;
                case /* string notes */ 4:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateVendorReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string orders_email = 2; */
        if (message.ordersEmail !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ordersEmail);
        /* string phone = 3; */
        if (message.phone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.phone);
        /* string notes = 4; */
        if (message.notes !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.CreateVendorReq
 */
export const CreateVendorReq = new CreateVendorReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateVendorRes$Type extends MessageType<CreateVendorRes> {
    constructor() {
        super("rd.api.vendors.CreateVendorRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateVendorRes>): CreateVendorRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateVendorRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateVendorRes): CreateVendorRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateVendorRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.CreateVendorRes
 */
export const CreateVendorRes = new CreateVendorRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertVendorsReq$Type extends MessageType<BulkUpsertVendorsReq> {
    constructor() {
        super("rd.api.vendors.BulkUpsertVendorsReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "write_changes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertVendorsReq>): BulkUpsertVendorsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        message.writeChanges = false;
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertVendorsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertVendorsReq): BulkUpsertVendorsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* bool write_changes */ 2:
                    message.writeChanges = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertVendorsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* bool write_changes = 2; */
        if (message.writeChanges !== false)
            writer.tag(2, WireType.Varint).bool(message.writeChanges);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.BulkUpsertVendorsReq
 */
export const BulkUpsertVendorsReq = new BulkUpsertVendorsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkUpsertVendorsRes$Type extends MessageType<BulkUpsertVendorsRes> {
    constructor() {
        super("rd.api.vendors.BulkUpsertVendorsRes", [
            { no: 1, name: "summary", kind: "message", T: () => Summary }
        ]);
    }
    create(value?: PartialMessage<BulkUpsertVendorsRes>): BulkUpsertVendorsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkUpsertVendorsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkUpsertVendorsRes): BulkUpsertVendorsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.bub.Summary summary */ 1:
                    message.summary = Summary.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkUpsertVendorsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.bub.Summary summary = 1; */
        if (message.summary)
            Summary.internalBinaryWrite(message.summary, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.BulkUpsertVendorsRes
 */
export const BulkUpsertVendorsRes = new BulkUpsertVendorsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorInformationReq$Type extends MessageType<UpdateVendorInformationReq> {
    constructor() {
        super("rd.api.vendors.UpdateVendorInformationReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_phone": true } },
            { no: 5, name: "address", kind: "message", T: () => Address },
            { no: 6, name: "pay_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateVendorInformationReq>): UpdateVendorInformationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.phone = "";
        message.payTo = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorInformationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorInformationReq): UpdateVendorInformationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string phone */ 4:
                    message.phone = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 5:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* string pay_to */ 6:
                    message.payTo = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorInformationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string phone = 4; */
        if (message.phone !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.phone);
        /* rd.proto.address.Address address = 5; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string pay_to = 6; */
        if (message.payTo !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.payTo);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorInformationReq
 */
export const UpdateVendorInformationReq = new UpdateVendorInformationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorInformationRes$Type extends MessageType<UpdateVendorInformationRes> {
    constructor() {
        super("rd.api.vendors.UpdateVendorInformationRes", []);
    }
    create(value?: PartialMessage<UpdateVendorInformationRes>): UpdateVendorInformationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorInformationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorInformationRes): UpdateVendorInformationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorInformationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorInformationRes
 */
export const UpdateVendorInformationRes = new UpdateVendorInformationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorNotesReq$Type extends MessageType<UpdateVendorNotesReq> {
    constructor() {
        super("rd.api.vendors.UpdateVendorNotesReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateVendorNotesReq>): UpdateVendorNotesReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorNotesReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorNotesReq): UpdateVendorNotesReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string notes */ 2:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorNotesReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 2; */
        if (message.notes !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorNotesReq
 */
export const UpdateVendorNotesReq = new UpdateVendorNotesReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorNotesRes$Type extends MessageType<UpdateVendorNotesRes> {
    constructor() {
        super("rd.api.vendors.UpdateVendorNotesRes", []);
    }
    create(value?: PartialMessage<UpdateVendorNotesRes>): UpdateVendorNotesRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorNotesRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorNotesRes): UpdateVendorNotesRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorNotesRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorNotesRes
 */
export const UpdateVendorNotesRes = new UpdateVendorNotesRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorIsActiveReq$Type extends MessageType<UpdateVendorIsActiveReq> {
    constructor() {
        super("rd.api.vendors.UpdateVendorIsActiveReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateVendorIsActiveReq>): UpdateVendorIsActiveReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.active = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorIsActiveReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorIsActiveReq): UpdateVendorIsActiveReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* bool active */ 2:
                    message.active = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorIsActiveReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool active = 2; */
        if (message.active !== false)
            writer.tag(2, WireType.Varint).bool(message.active);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorIsActiveReq
 */
export const UpdateVendorIsActiveReq = new UpdateVendorIsActiveReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorIsActiveRes$Type extends MessageType<UpdateVendorIsActiveRes> {
    constructor() {
        super("rd.api.vendors.UpdateVendorIsActiveRes", []);
    }
    create(value?: PartialMessage<UpdateVendorIsActiveRes>): UpdateVendorIsActiveRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorIsActiveRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorIsActiveRes): UpdateVendorIsActiveRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorIsActiveRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorIsActiveRes
 */
export const UpdateVendorIsActiveRes = new UpdateVendorIsActiveRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVendorReq$Type extends MessageType<GetVendorReq> {
    constructor() {
        super("rd.api.vendors.GetVendorReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetVendorReq>): GetVendorReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetVendorReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVendorReq): GetVendorReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVendorReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.GetVendorReq
 */
export const GetVendorReq = new GetVendorReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVendorRes$Type extends MessageType<GetVendorRes> {
    constructor() {
        super("rd.api.vendors.GetVendorRes", [
            { no: 1, name: "vendor", kind: "message", T: () => Vendor },
            { no: 2, name: "contacts", kind: "message", T: () => Contacts },
            { no: 3, name: "bank_payment_method", kind: "message", T: () => BankPaymentMethod }
        ]);
    }
    create(value?: PartialMessage<GetVendorRes>): GetVendorRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetVendorRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVendorRes): GetVendorRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.vendors.Vendor vendor */ 1:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.vendors.Contacts contacts */ 2:
                    message.contacts = Contacts.internalBinaryRead(reader, reader.uint32(), options, message.contacts);
                    break;
                case /* rd.payments.BankPaymentMethod bank_payment_method */ 3:
                    message.bankPaymentMethod = BankPaymentMethod.internalBinaryRead(reader, reader.uint32(), options, message.bankPaymentMethod);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVendorRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.vendors.Vendor vendor = 1; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Contacts contacts = 2; */
        if (message.contacts)
            Contacts.internalBinaryWrite(message.contacts, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.payments.BankPaymentMethod bank_payment_method = 3; */
        if (message.bankPaymentMethod)
            BankPaymentMethod.internalBinaryWrite(message.bankPaymentMethod, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.GetVendorRes
 */
export const GetVendorRes = new GetVendorRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVendorByIntegrationReq$Type extends MessageType<GetVendorByIntegrationReq> {
    constructor() {
        super("rd.api.vendors.GetVendorByIntegrationReq", [
            { no: 1, name: "integration_vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"], options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetVendorByIntegrationReq>): GetVendorByIntegrationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.integrationVendor = 0;
        if (value !== undefined)
            reflectionMergePartial<GetVendorByIntegrationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVendorByIntegrationReq): GetVendorByIntegrationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.integration_vendor.IntegrationVendor integration_vendor */ 1:
                    message.integrationVendor = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVendorByIntegrationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.integration_vendor.IntegrationVendor integration_vendor = 1; */
        if (message.integrationVendor !== 0)
            writer.tag(1, WireType.Varint).int32(message.integrationVendor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.GetVendorByIntegrationReq
 */
export const GetVendorByIntegrationReq = new GetVendorByIntegrationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetVendorByIntegrationRes$Type extends MessageType<GetVendorByIntegrationRes> {
    constructor() {
        super("rd.api.vendors.GetVendorByIntegrationRes", [
            { no: 1, name: "vendor", kind: "message", T: () => Vendor }
        ]);
    }
    create(value?: PartialMessage<GetVendorByIntegrationRes>): GetVendorByIntegrationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetVendorByIntegrationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetVendorByIntegrationRes): GetVendorByIntegrationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.vendors.Vendor vendor */ 1:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetVendorByIntegrationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.vendors.Vendor vendor = 1; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.GetVendorByIntegrationRes
 */
export const GetVendorByIntegrationRes = new GetVendorByIntegrationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListVendorsForCompanyReq$Type extends MessageType<ListVendorsForCompanyReq> {
    constructor() {
        super("rd.api.vendors.ListVendorsForCompanyReq", [
            { no: 1, name: "filter_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "filter_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "filter_connected_integration_vendor", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListVendorsForCompanyReq>): ListVendorsForCompanyReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filterActive = false;
        message.filterIds = [];
        message.filterConnectedIntegrationVendor = false;
        if (value !== undefined)
            reflectionMergePartial<ListVendorsForCompanyReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListVendorsForCompanyReq): ListVendorsForCompanyReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool filter_active */ 1:
                    message.filterActive = reader.bool();
                    break;
                case /* repeated rd.proto.uuid.UUID filter_ids */ 2:
                    message.filterIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool filter_connected_integration_vendor */ 3:
                    message.filterConnectedIntegrationVendor = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListVendorsForCompanyReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool filter_active = 1; */
        if (message.filterActive !== false)
            writer.tag(1, WireType.Varint).bool(message.filterActive);
        /* repeated rd.proto.uuid.UUID filter_ids = 2; */
        for (let i = 0; i < message.filterIds.length; i++)
            UUID.internalBinaryWrite(message.filterIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool filter_connected_integration_vendor = 3; */
        if (message.filterConnectedIntegrationVendor !== false)
            writer.tag(3, WireType.Varint).bool(message.filterConnectedIntegrationVendor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.ListVendorsForCompanyReq
 */
export const ListVendorsForCompanyReq = new ListVendorsForCompanyReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListVendorsForCompanyRes$Type extends MessageType<ListVendorsForCompanyRes> {
    constructor() {
        super("rd.api.vendors.ListVendorsForCompanyRes", [
            { no: 1, name: "vendors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Vendor }
        ]);
    }
    create(value?: PartialMessage<ListVendorsForCompanyRes>): ListVendorsForCompanyRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vendors = [];
        if (value !== undefined)
            reflectionMergePartial<ListVendorsForCompanyRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListVendorsForCompanyRes): ListVendorsForCompanyRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.vendors.Vendor vendors */ 1:
                    message.vendors.push(Vendor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListVendorsForCompanyRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.vendors.Vendor vendors = 1; */
        for (let i = 0; i < message.vendors.length; i++)
            Vendor.internalBinaryWrite(message.vendors[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.ListVendorsForCompanyRes
 */
export const ListVendorsForCompanyRes = new ListVendorsForCompanyRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveVendorCountReq$Type extends MessageType<GetActiveVendorCountReq> {
    constructor() {
        super("rd.api.vendors.GetActiveVendorCountReq", []);
    }
    create(value?: PartialMessage<GetActiveVendorCountReq>): GetActiveVendorCountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetActiveVendorCountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveVendorCountReq): GetActiveVendorCountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveVendorCountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.GetActiveVendorCountReq
 */
export const GetActiveVendorCountReq = new GetActiveVendorCountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveVendorCountRes$Type extends MessageType<GetActiveVendorCountRes> {
    constructor() {
        super("rd.api.vendors.GetActiveVendorCountRes", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetActiveVendorCountRes>): GetActiveVendorCountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetActiveVendorCountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetActiveVendorCountRes): GetActiveVendorCountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetActiveVendorCountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.GetActiveVendorCountRes
 */
export const GetActiveVendorCountRes = new GetActiveVendorCountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveVendorBankPaymentMethodReq$Type extends MessageType<SaveVendorBankPaymentMethodReq> {
    constructor() {
        super("rd.api.vendors.SaveVendorBankPaymentMethodReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "stripe_payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<SaveVendorBankPaymentMethodReq>): SaveVendorBankPaymentMethodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripePaymentMethodId = "";
        if (value !== undefined)
            reflectionMergePartial<SaveVendorBankPaymentMethodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaveVendorBankPaymentMethodReq): SaveVendorBankPaymentMethodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string stripe_payment_method_id */ 2:
                    message.stripePaymentMethodId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaveVendorBankPaymentMethodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_payment_method_id = 2; */
        if (message.stripePaymentMethodId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripePaymentMethodId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.SaveVendorBankPaymentMethodReq
 */
export const SaveVendorBankPaymentMethodReq = new SaveVendorBankPaymentMethodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveVendorBankPaymentMethodRes$Type extends MessageType<SaveVendorBankPaymentMethodRes> {
    constructor() {
        super("rd.api.vendors.SaveVendorBankPaymentMethodRes", []);
    }
    create(value?: PartialMessage<SaveVendorBankPaymentMethodRes>): SaveVendorBankPaymentMethodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SaveVendorBankPaymentMethodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaveVendorBankPaymentMethodRes): SaveVendorBankPaymentMethodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaveVendorBankPaymentMethodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.SaveVendorBankPaymentMethodRes
 */
export const SaveVendorBankPaymentMethodRes = new SaveVendorBankPaymentMethodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteVendorBankPaymentMethodReq$Type extends MessageType<DeleteVendorBankPaymentMethodReq> {
    constructor() {
        super("rd.api.vendors.DeleteVendorBankPaymentMethodReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeleteVendorBankPaymentMethodReq>): DeleteVendorBankPaymentMethodReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteVendorBankPaymentMethodReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteVendorBankPaymentMethodReq): DeleteVendorBankPaymentMethodReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteVendorBankPaymentMethodReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.DeleteVendorBankPaymentMethodReq
 */
export const DeleteVendorBankPaymentMethodReq = new DeleteVendorBankPaymentMethodReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteVendorBankPaymentMethodRes$Type extends MessageType<DeleteVendorBankPaymentMethodRes> {
    constructor() {
        super("rd.api.vendors.DeleteVendorBankPaymentMethodRes", []);
    }
    create(value?: PartialMessage<DeleteVendorBankPaymentMethodRes>): DeleteVendorBankPaymentMethodRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteVendorBankPaymentMethodRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteVendorBankPaymentMethodRes): DeleteVendorBankPaymentMethodRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteVendorBankPaymentMethodRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.DeleteVendorBankPaymentMethodRes
 */
export const DeleteVendorBankPaymentMethodRes = new DeleteVendorBankPaymentMethodRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateVendorWithBankAccountReq$Type extends MessageType<CreateVendorWithBankAccountReq> {
    constructor() {
        super("rd.api.vendors.CreateVendorWithBankAccountReq", [
            { no: 1, name: "vendor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "stripe_payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<CreateVendorWithBankAccountReq>): CreateVendorWithBankAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vendorName = "";
        message.stripePaymentMethodId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateVendorWithBankAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateVendorWithBankAccountReq): CreateVendorWithBankAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string vendor_name */ 1:
                    message.vendorName = reader.string();
                    break;
                case /* string stripe_payment_method_id */ 2:
                    message.stripePaymentMethodId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateVendorWithBankAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string vendor_name = 1; */
        if (message.vendorName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.vendorName);
        /* string stripe_payment_method_id = 2; */
        if (message.stripePaymentMethodId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripePaymentMethodId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.CreateVendorWithBankAccountReq
 */
export const CreateVendorWithBankAccountReq = new CreateVendorWithBankAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateVendorWithBankAccountRes$Type extends MessageType<CreateVendorWithBankAccountRes> {
    constructor() {
        super("rd.api.vendors.CreateVendorWithBankAccountRes", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateVendorWithBankAccountRes>): CreateVendorWithBankAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateVendorWithBankAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateVendorWithBankAccountRes): CreateVendorWithBankAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateVendorWithBankAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.CreateVendorWithBankAccountRes
 */
export const CreateVendorWithBankAccountRes = new CreateVendorWithBankAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertVendorBankAccountReq$Type extends MessageType<UpsertVendorBankAccountReq> {
    constructor() {
        super("rd.api.vendors.UpsertVendorBankAccountReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "stripe_payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpsertVendorBankAccountReq>): UpsertVendorBankAccountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripePaymentMethodId = "";
        if (value !== undefined)
            reflectionMergePartial<UpsertVendorBankAccountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertVendorBankAccountReq): UpsertVendorBankAccountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string stripe_payment_method_id */ 2:
                    message.stripePaymentMethodId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpsertVendorBankAccountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_payment_method_id = 2; */
        if (message.stripePaymentMethodId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripePaymentMethodId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpsertVendorBankAccountReq
 */
export const UpsertVendorBankAccountReq = new UpsertVendorBankAccountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertVendorBankAccountRes$Type extends MessageType<UpsertVendorBankAccountRes> {
    constructor() {
        super("rd.api.vendors.UpsertVendorBankAccountRes", []);
    }
    create(value?: PartialMessage<UpsertVendorBankAccountRes>): UpsertVendorBankAccountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpsertVendorBankAccountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertVendorBankAccountRes): UpsertVendorBankAccountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpsertVendorBankAccountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpsertVendorBankAccountRes
 */
export const UpsertVendorBankAccountRes = new UpsertVendorBankAccountRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorSettingsByLocationReq$Type extends MessageType<UpdateVendorSettingsByLocationReq> {
    constructor() {
        super("rd.api.vendors.UpdateVendorSettingsByLocationReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "default_account_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "settings_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => VendorLocationSettings } }
        ]);
    }
    create(value?: PartialMessage<UpdateVendorSettingsByLocationReq>): UpdateVendorSettingsByLocationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultAccountNumber = "";
        message.settingsByLocationId = {};
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorSettingsByLocationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorSettingsByLocationReq): UpdateVendorSettingsByLocationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string default_account_number */ 2:
                    message.defaultAccountNumber = reader.string();
                    break;
                case /* map<string, rd.vendors.VendorLocationSettings> settings_by_location_id */ 3:
                    this.binaryReadMap3(message.settingsByLocationId, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: UpdateVendorSettingsByLocationReq["settingsByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpdateVendorSettingsByLocationReq["settingsByLocationId"] | undefined, val: UpdateVendorSettingsByLocationReq["settingsByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = VendorLocationSettings.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.vendors.UpdateVendorSettingsByLocationReq.settings_by_location_id");
            }
        }
        map[key ?? ""] = val ?? VendorLocationSettings.create();
    }
    internalBinaryWrite(message: UpdateVendorSettingsByLocationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string default_account_number = 2; */
        if (message.defaultAccountNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.defaultAccountNumber);
        /* map<string, rd.vendors.VendorLocationSettings> settings_by_location_id = 3; */
        for (let k of globalThis.Object.keys(message.settingsByLocationId)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            VendorLocationSettings.internalBinaryWrite(message.settingsByLocationId[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorSettingsByLocationReq
 */
export const UpdateVendorSettingsByLocationReq = new UpdateVendorSettingsByLocationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorSettingsByLocationRes$Type extends MessageType<UpdateVendorSettingsByLocationRes> {
    constructor() {
        super("rd.api.vendors.UpdateVendorSettingsByLocationRes", []);
    }
    create(value?: PartialMessage<UpdateVendorSettingsByLocationRes>): UpdateVendorSettingsByLocationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorSettingsByLocationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorSettingsByLocationRes): UpdateVendorSettingsByLocationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorSettingsByLocationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorSettingsByLocationRes
 */
export const UpdateVendorSettingsByLocationRes = new UpdateVendorSettingsByLocationRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateVendorContactReq$Type extends MessageType<CreateVendorContactReq> {
    constructor() {
        super("rd.api.vendors.CreateVendorContactReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_phone": true } },
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_email": true } },
            { no: 5, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateVendorContactReq>): CreateVendorContactReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.phone = "";
        message.email = "";
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<CreateVendorContactReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateVendorContactReq): CreateVendorContactReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string phone */ 3:
                    message.phone = reader.string();
                    break;
                case /* string email */ 4:
                    message.email = reader.string();
                    break;
                case /* string notes */ 5:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateVendorContactReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string phone = 3; */
        if (message.phone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.phone);
        /* string email = 4; */
        if (message.email !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.email);
        /* string notes = 5; */
        if (message.notes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.CreateVendorContactReq
 */
export const CreateVendorContactReq = new CreateVendorContactReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateVendorContactRes$Type extends MessageType<CreateVendorContactRes> {
    constructor() {
        super("rd.api.vendors.CreateVendorContactRes", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateVendorContactRes>): CreateVendorContactRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<CreateVendorContactRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateVendorContactRes): CreateVendorContactRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateVendorContactRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.CreateVendorContactRes
 */
export const CreateVendorContactRes = new CreateVendorContactRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorContactReq$Type extends MessageType<UpdateVendorContactReq> {
    constructor() {
        super("rd.api.vendors.UpdateVendorContactReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 4, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_phone": true } },
            { no: 5, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_email": true } },
            { no: 6, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateVendorContactReq>): UpdateVendorContactReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.name = "";
        message.phone = "";
        message.email = "";
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorContactReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorContactReq): UpdateVendorContactReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string id_string */ 2:
                    message.idString = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string phone */ 4:
                    message.phone = reader.string();
                    break;
                case /* string email */ 5:
                    message.email = reader.string();
                    break;
                case /* string notes */ 6:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorContactReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string id_string = 2; */
        if (message.idString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.idString);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string phone = 4; */
        if (message.phone !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.phone);
        /* string email = 5; */
        if (message.email !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.email);
        /* string notes = 6; */
        if (message.notes !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorContactReq
 */
export const UpdateVendorContactReq = new UpdateVendorContactReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorContactRes$Type extends MessageType<UpdateVendorContactRes> {
    constructor() {
        super("rd.api.vendors.UpdateVendorContactRes", []);
    }
    create(value?: PartialMessage<UpdateVendorContactRes>): UpdateVendorContactRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorContactRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorContactRes): UpdateVendorContactRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorContactRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorContactRes
 */
export const UpdateVendorContactRes = new UpdateVendorContactRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateVendorContactReq$Type extends MessageType<DeactivateVendorContactReq> {
    constructor() {
        super("rd.api.vendors.DeactivateVendorContactReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateVendorContactReq>): DeactivateVendorContactReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        if (value !== undefined)
            reflectionMergePartial<DeactivateVendorContactReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateVendorContactReq): DeactivateVendorContactReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* string id_string */ 2:
                    message.idString = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateVendorContactReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string id_string = 2; */
        if (message.idString !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.idString);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.DeactivateVendorContactReq
 */
export const DeactivateVendorContactReq = new DeactivateVendorContactReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateVendorContactRes$Type extends MessageType<DeactivateVendorContactRes> {
    constructor() {
        super("rd.api.vendors.DeactivateVendorContactRes", []);
    }
    create(value?: PartialMessage<DeactivateVendorContactRes>): DeactivateVendorContactRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateVendorContactRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateVendorContactRes): DeactivateVendorContactRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateVendorContactRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.DeactivateVendorContactRes
 */
export const DeactivateVendorContactRes = new DeactivateVendorContactRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateVendorReq$Type extends MessageType<DuplicateVendorReq> {
    constructor() {
        super("rd.api.vendors.DuplicateVendorReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DuplicateVendorReq>): DuplicateVendorReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DuplicateVendorReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DuplicateVendorReq): DuplicateVendorReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DuplicateVendorReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.DuplicateVendorReq
 */
export const DuplicateVendorReq = new DuplicateVendorReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateVendorRes$Type extends MessageType<DuplicateVendorRes> {
    constructor() {
        super("rd.api.vendors.DuplicateVendorRes", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<DuplicateVendorRes>): DuplicateVendorRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DuplicateVendorRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DuplicateVendorRes): DuplicateVendorRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DuplicateVendorRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.DuplicateVendorRes
 */
export const DuplicateVendorRes = new DuplicateVendorRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorOrderSettingsReq$Type extends MessageType<UpdateVendorOrderSettingsReq> {
    constructor() {
        super("rd.api.vendors.UpdateVendorOrderSettingsReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "disable_pdf_attachments", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "disable_excel_attachments", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "orders_email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.is_email": true } },
            { no: 5, name: "should_send_prices_on_po", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateVendorOrderSettingsReq>): UpdateVendorOrderSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.disablePdfAttachments = false;
        message.disableExcelAttachments = false;
        message.ordersEmail = "";
        message.shouldSendPricesOnPo = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorOrderSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorOrderSettingsReq): UpdateVendorOrderSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* bool disable_pdf_attachments */ 2:
                    message.disablePdfAttachments = reader.bool();
                    break;
                case /* bool disable_excel_attachments */ 3:
                    message.disableExcelAttachments = reader.bool();
                    break;
                case /* string orders_email */ 4:
                    message.ordersEmail = reader.string();
                    break;
                case /* bool should_send_prices_on_po */ 5:
                    message.shouldSendPricesOnPo = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorOrderSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool disable_pdf_attachments = 2; */
        if (message.disablePdfAttachments !== false)
            writer.tag(2, WireType.Varint).bool(message.disablePdfAttachments);
        /* bool disable_excel_attachments = 3; */
        if (message.disableExcelAttachments !== false)
            writer.tag(3, WireType.Varint).bool(message.disableExcelAttachments);
        /* string orders_email = 4; */
        if (message.ordersEmail !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.ordersEmail);
        /* bool should_send_prices_on_po = 5; */
        if (message.shouldSendPricesOnPo !== false)
            writer.tag(5, WireType.Varint).bool(message.shouldSendPricesOnPo);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorOrderSettingsReq
 */
export const UpdateVendorOrderSettingsReq = new UpdateVendorOrderSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorOrderSettingsRes$Type extends MessageType<UpdateVendorOrderSettingsRes> {
    constructor() {
        super("rd.api.vendors.UpdateVendorOrderSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateVendorOrderSettingsRes>): UpdateVendorOrderSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorOrderSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorOrderSettingsRes): UpdateVendorOrderSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorOrderSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorOrderSettingsRes
 */
export const UpdateVendorOrderSettingsRes = new UpdateVendorOrderSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorOrderReceiveSettingsReq$Type extends MessageType<UpdateVendorOrderReceiveSettingsReq> {
    constructor() {
        super("rd.api.vendors.UpdateVendorOrderReceiveSettingsReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "order_receive_settings", kind: "message", T: () => OrderReceiveSettings, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateVendorOrderReceiveSettingsReq>): UpdateVendorOrderReceiveSettingsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorOrderReceiveSettingsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorOrderReceiveSettingsReq): UpdateVendorOrderReceiveSettingsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.vendors.OrderReceiveSettings order_receive_settings */ 2:
                    message.orderReceiveSettings = OrderReceiveSettings.internalBinaryRead(reader, reader.uint32(), options, message.orderReceiveSettings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorOrderReceiveSettingsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.OrderReceiveSettings order_receive_settings = 2; */
        if (message.orderReceiveSettings)
            OrderReceiveSettings.internalBinaryWrite(message.orderReceiveSettings, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorOrderReceiveSettingsReq
 */
export const UpdateVendorOrderReceiveSettingsReq = new UpdateVendorOrderReceiveSettingsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorOrderReceiveSettingsRes$Type extends MessageType<UpdateVendorOrderReceiveSettingsRes> {
    constructor() {
        super("rd.api.vendors.UpdateVendorOrderReceiveSettingsRes", []);
    }
    create(value?: PartialMessage<UpdateVendorOrderReceiveSettingsRes>): UpdateVendorOrderReceiveSettingsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorOrderReceiveSettingsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorOrderReceiveSettingsRes): UpdateVendorOrderReceiveSettingsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorOrderReceiveSettingsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorOrderReceiveSettingsRes
 */
export const UpdateVendorOrderReceiveSettingsRes = new UpdateVendorOrderReceiveSettingsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignVendorSkusReq$Type extends MessageType<AssignVendorSkusReq> {
    constructor() {
        super("rd.api.vendors.AssignVendorSkusReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "should_sync_product_data", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "only_match_by_upc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "should_sync_prices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AssignVendorSkusReq>): AssignVendorSkusReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldSyncProductData = false;
        message.onlyMatchByUpc = false;
        message.shouldSyncPrices = false;
        if (value !== undefined)
            reflectionMergePartial<AssignVendorSkusReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssignVendorSkusReq): AssignVendorSkusReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* bool should_sync_product_data */ 2:
                    message.shouldSyncProductData = reader.bool();
                    break;
                case /* bool only_match_by_upc */ 3:
                    message.onlyMatchByUpc = reader.bool();
                    break;
                case /* bool should_sync_prices */ 4:
                    message.shouldSyncPrices = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssignVendorSkusReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_sync_product_data = 2; */
        if (message.shouldSyncProductData !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldSyncProductData);
        /* bool only_match_by_upc = 3; */
        if (message.onlyMatchByUpc !== false)
            writer.tag(3, WireType.Varint).bool(message.onlyMatchByUpc);
        /* bool should_sync_prices = 4; */
        if (message.shouldSyncPrices !== false)
            writer.tag(4, WireType.Varint).bool(message.shouldSyncPrices);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.AssignVendorSkusReq
 */
export const AssignVendorSkusReq = new AssignVendorSkusReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignVendorSkusRes$Type extends MessageType<AssignVendorSkusRes> {
    constructor() {
        super("rd.api.vendors.AssignVendorSkusRes", []);
    }
    create(value?: PartialMessage<AssignVendorSkusRes>): AssignVendorSkusRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AssignVendorSkusRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AssignVendorSkusRes): AssignVendorSkusRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AssignVendorSkusRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.AssignVendorSkusRes
 */
export const AssignVendorSkusRes = new AssignVendorSkusRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListVendorIntegrationOptionsReq$Type extends MessageType<ListVendorIntegrationOptionsReq> {
    constructor() {
        super("rd.api.vendors.ListVendorIntegrationOptionsReq", []);
    }
    create(value?: PartialMessage<ListVendorIntegrationOptionsReq>): ListVendorIntegrationOptionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListVendorIntegrationOptionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListVendorIntegrationOptionsReq): ListVendorIntegrationOptionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListVendorIntegrationOptionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.ListVendorIntegrationOptionsReq
 */
export const ListVendorIntegrationOptionsReq = new ListVendorIntegrationOptionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorIntegrationOption$Type extends MessageType<VendorIntegrationOption> {
    constructor() {
        super("rd.api.vendors.VendorIntegrationOption", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "integration_vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] }
        ]);
    }
    create(value?: PartialMessage<VendorIntegrationOption>): VendorIntegrationOption {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.integrationVendor = 0;
        if (value !== undefined)
            reflectionMergePartial<VendorIntegrationOption>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorIntegrationOption): VendorIntegrationOption {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor integration_vendor */ 2:
                    message.integrationVendor = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorIntegrationOption, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.integration_vendor.IntegrationVendor integration_vendor = 2; */
        if (message.integrationVendor !== 0)
            writer.tag(2, WireType.Varint).int32(message.integrationVendor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.VendorIntegrationOption
 */
export const VendorIntegrationOption = new VendorIntegrationOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListVendorIntegrationOptionsRes$Type extends MessageType<ListVendorIntegrationOptionsRes> {
    constructor() {
        super("rd.api.vendors.ListVendorIntegrationOptionsRes", [
            { no: 1, name: "vendor_integration_options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VendorIntegrationOption }
        ]);
    }
    create(value?: PartialMessage<ListVendorIntegrationOptionsRes>): ListVendorIntegrationOptionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vendorIntegrationOptions = [];
        if (value !== undefined)
            reflectionMergePartial<ListVendorIntegrationOptionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListVendorIntegrationOptionsRes): ListVendorIntegrationOptionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.vendors.VendorIntegrationOption vendor_integration_options */ 1:
                    message.vendorIntegrationOptions.push(VendorIntegrationOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListVendorIntegrationOptionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.vendors.VendorIntegrationOption vendor_integration_options = 1; */
        for (let i = 0; i < message.vendorIntegrationOptions.length; i++)
            VendorIntegrationOption.internalBinaryWrite(message.vendorIntegrationOptions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.ListVendorIntegrationOptionsRes
 */
export const ListVendorIntegrationOptionsRes = new ListVendorIntegrationOptionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VendorLocationSettingsOption$Type extends MessageType<VendorLocationSettingsOption> {
    constructor() {
        super("rd.api.vendors.VendorLocationSettingsOption", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VendorLocationSettingsOption>): VendorLocationSettingsOption {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.label = "";
        if (value !== undefined)
            reflectionMergePartial<VendorLocationSettingsOption>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VendorLocationSettingsOption): VendorLocationSettingsOption {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VendorLocationSettingsOption, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.VendorLocationSettingsOption
 */
export const VendorLocationSettingsOption = new VendorLocationSettingsOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListVendorLocationSettingsOptionsReq$Type extends MessageType<ListVendorLocationSettingsOptionsReq> {
    constructor() {
        super("rd.api.vendors.ListVendorLocationSettingsOptionsReq", [
            { no: 1, name: "integration_vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"], options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListVendorLocationSettingsOptionsReq>): ListVendorLocationSettingsOptionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.integrationVendor = 0;
        if (value !== undefined)
            reflectionMergePartial<ListVendorLocationSettingsOptionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListVendorLocationSettingsOptionsReq): ListVendorLocationSettingsOptionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.integration_vendor.IntegrationVendor integration_vendor */ 1:
                    message.integrationVendor = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListVendorLocationSettingsOptionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.integration_vendor.IntegrationVendor integration_vendor = 1; */
        if (message.integrationVendor !== 0)
            writer.tag(1, WireType.Varint).int32(message.integrationVendor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.ListVendorLocationSettingsOptionsReq
 */
export const ListVendorLocationSettingsOptionsReq = new ListVendorLocationSettingsOptionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListVendorLocationSettingsOptionsRes$Type extends MessageType<ListVendorLocationSettingsOptionsRes> {
    constructor() {
        super("rd.api.vendors.ListVendorLocationSettingsOptionsRes", [
            { no: 1, name: "warehouse_options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VendorLocationSettingsOption },
            { no: 2, name: "pricing_tier_options", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VendorLocationSettingsOption }
        ]);
    }
    create(value?: PartialMessage<ListVendorLocationSettingsOptionsRes>): ListVendorLocationSettingsOptionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.warehouseOptions = [];
        message.pricingTierOptions = [];
        if (value !== undefined)
            reflectionMergePartial<ListVendorLocationSettingsOptionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListVendorLocationSettingsOptionsRes): ListVendorLocationSettingsOptionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.vendors.VendorLocationSettingsOption warehouse_options */ 1:
                    message.warehouseOptions.push(VendorLocationSettingsOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.api.vendors.VendorLocationSettingsOption pricing_tier_options */ 2:
                    message.pricingTierOptions.push(VendorLocationSettingsOption.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListVendorLocationSettingsOptionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.vendors.VendorLocationSettingsOption warehouse_options = 1; */
        for (let i = 0; i < message.warehouseOptions.length; i++)
            VendorLocationSettingsOption.internalBinaryWrite(message.warehouseOptions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.vendors.VendorLocationSettingsOption pricing_tier_options = 2; */
        for (let i = 0; i < message.pricingTierOptions.length; i++)
            VendorLocationSettingsOption.internalBinaryWrite(message.pricingTierOptions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.ListVendorLocationSettingsOptionsRes
 */
export const ListVendorLocationSettingsOptionsRes = new ListVendorLocationSettingsOptionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCatalogVendorIntegrationOptionsReq$Type extends MessageType<ListCatalogVendorIntegrationOptionsReq> {
    constructor() {
        super("rd.api.vendors.ListCatalogVendorIntegrationOptionsReq", []);
    }
    create(value?: PartialMessage<ListCatalogVendorIntegrationOptionsReq>): ListCatalogVendorIntegrationOptionsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListCatalogVendorIntegrationOptionsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCatalogVendorIntegrationOptionsReq): ListCatalogVendorIntegrationOptionsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCatalogVendorIntegrationOptionsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.ListCatalogVendorIntegrationOptionsReq
 */
export const ListCatalogVendorIntegrationOptionsReq = new ListCatalogVendorIntegrationOptionsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCatalogVendorIntegrationOptionsRes$Type extends MessageType<ListCatalogVendorIntegrationOptionsRes> {
    constructor() {
        super("rd.api.vendors.ListCatalogVendorIntegrationOptionsRes", [
            { no: 1, name: "integration_vendors", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] }
        ]);
    }
    create(value?: PartialMessage<ListCatalogVendorIntegrationOptionsRes>): ListCatalogVendorIntegrationOptionsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.integrationVendors = [];
        if (value !== undefined)
            reflectionMergePartial<ListCatalogVendorIntegrationOptionsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListCatalogVendorIntegrationOptionsRes): ListCatalogVendorIntegrationOptionsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.integrationVendors.push(reader.int32());
                    else
                        message.integrationVendors.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListCatalogVendorIntegrationOptionsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.integration_vendor.IntegrationVendor integration_vendors = 1; */
        if (message.integrationVendors.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.integrationVendors.length; i++)
                writer.int32(message.integrationVendors[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.ListCatalogVendorIntegrationOptionsRes
 */
export const ListCatalogVendorIntegrationOptionsRes = new ListCatalogVendorIntegrationOptionsRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorIntegrationReq$Type extends MessageType<UpdateVendorIntegrationReq> {
    constructor() {
        super("rd.api.vendors.UpdateVendorIntegrationReq", [
            { no: 1, name: "vendor_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "integration_vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] }
        ]);
    }
    create(value?: PartialMessage<UpdateVendorIntegrationReq>): UpdateVendorIntegrationReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.integrationVendor = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorIntegrationReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorIntegrationReq): UpdateVendorIntegrationReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID vendor_id */ 1:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor integration_vendor */ 2:
                    message.integrationVendor = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorIntegrationReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID vendor_id = 1; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.integration_vendor.IntegrationVendor integration_vendor = 2; */
        if (message.integrationVendor !== 0)
            writer.tag(2, WireType.Varint).int32(message.integrationVendor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorIntegrationReq
 */
export const UpdateVendorIntegrationReq = new UpdateVendorIntegrationReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateVendorIntegrationRes$Type extends MessageType<UpdateVendorIntegrationRes> {
    constructor() {
        super("rd.api.vendors.UpdateVendorIntegrationRes", []);
    }
    create(value?: PartialMessage<UpdateVendorIntegrationRes>): UpdateVendorIntegrationRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateVendorIntegrationRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateVendorIntegrationRes): UpdateVendorIntegrationRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateVendorIntegrationRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.vendors.UpdateVendorIntegrationRes
 */
export const UpdateVendorIntegrationRes = new UpdateVendorIntegrationRes$Type();
/**
 * @generated ServiceType for protobuf service rd.api.vendors.VendorsService
 */
export const VendorsService = new ServiceType("rd.api.vendors.VendorsService", [
    { name: "CreateVendor", options: {}, I: CreateVendorReq, O: CreateVendorRes },
    { name: "BulkUpsertVendors", options: {}, I: BulkUpsertVendorsReq, O: BulkUpsertVendorsRes },
    { name: "UpdateVendorInformation", options: {}, I: UpdateVendorInformationReq, O: UpdateVendorInformationRes },
    { name: "UpdateVendorNotes", options: {}, I: UpdateVendorNotesReq, O: UpdateVendorNotesRes },
    { name: "UpdateVendorIsActive", options: {}, I: UpdateVendorIsActiveReq, O: UpdateVendorIsActiveRes },
    { name: "GetVendor", options: {}, I: GetVendorReq, O: GetVendorRes },
    { name: "GetVendorByIntegration", options: {}, I: GetVendorByIntegrationReq, O: GetVendorByIntegrationRes },
    { name: "ListVendorsForCompany", options: {}, I: ListVendorsForCompanyReq, O: ListVendorsForCompanyRes },
    { name: "GetActiveVendorCount", options: {}, I: GetActiveVendorCountReq, O: GetActiveVendorCountRes },
    { name: "SaveVendorBankPaymentMethod", options: {}, I: SaveVendorBankPaymentMethodReq, O: SaveVendorBankPaymentMethodRes },
    { name: "DeleteVendorBankPaymentMethod", options: {}, I: DeleteVendorBankPaymentMethodReq, O: DeleteVendorBankPaymentMethodRes },
    { name: "CreateVendorWithBankAccount", options: {}, I: CreateVendorWithBankAccountReq, O: CreateVendorWithBankAccountRes },
    { name: "UpsertVendorBankAccount", options: {}, I: UpsertVendorBankAccountReq, O: UpsertVendorBankAccountRes },
    { name: "UpdateVendorSettingsByLocation", options: {}, I: UpdateVendorSettingsByLocationReq, O: UpdateVendorSettingsByLocationRes },
    { name: "ListVendorLocationSettingsOptions", options: {}, I: ListVendorLocationSettingsOptionsReq, O: ListVendorLocationSettingsOptionsRes },
    { name: "DuplicateVendor", options: {}, I: DuplicateVendorReq, O: DuplicateVendorRes },
    { name: "UpdateVendorOrderSettings", options: {}, I: UpdateVendorOrderSettingsReq, O: UpdateVendorOrderSettingsRes },
    { name: "UpdateVendorOrderReceiveSettings", options: {}, I: UpdateVendorOrderReceiveSettingsReq, O: UpdateVendorOrderReceiveSettingsRes },
    { name: "AssignVendorSkus", options: {}, I: AssignVendorSkusReq, O: AssignVendorSkusRes },
    { name: "ListVendorIntegrationOptions", options: {}, I: ListVendorIntegrationOptionsReq, O: ListVendorIntegrationOptionsRes },
    { name: "UpdateVendorIntegration", options: {}, I: UpdateVendorIntegrationReq, O: UpdateVendorIntegrationRes },
    { name: "ListCatalogVendorIntegrationOptions", options: {}, I: ListCatalogVendorIntegrationOptionsReq, O: ListCatalogVendorIntegrationOptionsRes },
    { name: "CreateVendorContact", options: {}, I: CreateVendorContactReq, O: CreateVendorContactRes },
    { name: "UpdateVendorContact", options: {}, I: UpdateVendorContactReq, O: UpdateVendorContactRes },
    { name: "DeactivateVendorContact", options: {}, I: DeactivateVendorContactReq, O: DeactivateVendorContactRes }
]);
